import useTranslation from "@casino/legacy/client/hooks/i18n/useTranslation";
import useDidUpdate from "@casino/legacy/client/hooks/lifecycle/useDidUpdate";
import useDateInputForm from "./useDateInputForm";

const currentYear = new Date().getFullYear();
const minYear = currentYear - 100;
const maxYear = currentYear - 18;

type Props = {
  initial?: number;
  adultOnly?: boolean;
  onChange?: (value?: Partial<DayMonthYear>) => void;
};

const useDateInput = ({ initial, adultOnly, onChange }: Props) => {
  const { values, handleChange } = useDateInputForm(initial);
  const dayLabel = useTranslation("general.day");
  const monthLabel = useTranslation("general.month");
  const yearLabel = useTranslation("general.year");

  useDidUpdate(() => {
    onChange?.(values);
  }, [values.day, values.month, values.year]);

  return {
    values,
    dayLabel,
    monthLabel,
    yearLabel,
    minYear,
    maxYear: adultOnly ? maxYear : currentYear,
    handleChange,
  };
};

export default useDateInput;
